<template>
  <div>
    <a v-if="meetingInstance.googleDocumentUrl" :href="meetingInstance.googleDocumentUrl" target="_blank" rel="noopener noreferrer">
      Open document in Google
    </a>
    <i v-else>No document</i>
  </div>
</template>

<script>
export default {
  props: ["step", "meetingInstance"]
};
</script>
